import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { HearingsApiService } from 'src/app/core/services/api/hearings-api.service';
import { Expert } from '../../models/hearings/expert';

@Component({
  selector: 'app-expert-create-edit',
  templateUrl: './expert-create-edit.component.html',
  styleUrls: ['./expert-create-edit.component.scss']
})
export class ExpertCreateEditComponent implements OnInit {
  public expert: Expert;

  @ViewChild('expertsModal') expertsModal;
  @Output() submit: EventEmitter<Expert> = new EventEmitter<Expert>();

  modalRef: NgbModalRef;

  constructor(private modalService: NgbModal,
    private api: HearingsApiService,
    private spinner: NgxSpinnerService
  ) { }

  ngOnInit(): void {
  }

  // handle the popup
  open(expert: Expert) {
    this.expert = Object.assign(new Expert(), expert);
    this.modalRef = this.modalService.open(this.expertsModal, { centered: true, size: 'lg' });
  }

  close() {
    this.modalRef.close();
  }

  onSubmit() {
    if (this.expert.id) {
      this.spinner.show();
      this.api.updateExpert(this.expert).subscribe(
        c => {
          this.spinner.hide();
          this.submit.emit(c);
        }
      )
    } else {
      this.spinner.show();
      this.api.createExpert(this.expert).subscribe(
        c => {
          this.spinner.hide();
          this.submit.emit(c);
        }
      )
    }
  }

}

